const lang = {
  'frontend.global.operation.confirm': '確認',
  'frontend.global.operation.ok': '確定',
  'frontend.global.operation.save': '儲存',
  'frontend.global.operation.finished': '完成',
  'frontend.global.operation.cancel': '取消',
  'frontend.global.operation.signin': '登入',
  'frontend.global.operation.signout': '登出',
  'frontend.global.operation.more': 'See all Projects',
  'frontend.global.operation.viewalll': '查看全部',
  'frontend.global.operation.menuopen': 'Menu',
  'frontend.global.operation.menuclose': 'Close',

  'frontend.global.property.websiteenv': '測試版',
  'frontend.global.property.websitetitle': 'Bridge Builder',
  'frontend.global.property.username': '使用者名稱',
  'frontend.global.property.password': '密碼',
  'frontend.global.property.or': '或',
  'frontend.global.property.validate': '驗證中',
  'frontend.global.property.userlogout': '登出',
  'frontend.global.property.language_en': 'English',
  'frontend.global.property.language_tw': '中文',
  'frontend.global.property.fontsize': '字體大小',
  'frontend.global.property.allwrite': '©{0} Bridge Builder',

  'frontend.global.route.home': '首頁',
  'frontend.global.route.service': '服務',
  'frontend.global.route.project': '專案',
  'frontend.global.route.contact': '聯絡我們',

  'frontend.global.hint.username': '請輸入使用者名稱',
  'frontend.global.hint.password': '請輸入密碼',

  'frontend.global.error.0000': '糟糕！',

  'frontend.local.home.title': 'Bridge Builder:\n連結創意、人群與文化',

  'frontend.local.service.title': `展覽策劃\n活動統籌與經紀`,

  'frontend.local.contact.vatnumber': '統一編號',

  'frontend.local.projects.title': '專案作品',
  'frontend.local.projects.time': '日期',
  'frontend.local.projects.location': '地點',
  'frontend.local.projects.curator': '策展人',

  'frontend.local.contact.title': `讓我們一起合作`
};

export default lang;
